import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { number } from "zod";

interface iSideBar {
  sidebarHidden: boolean;
  sidebarExpanded: boolean;
  sidebarChats: boolean;
  titleTab: string;
  lastMessageSent: string;
  allDialogs: number[];
  updateShowInput: boolean;
  notificationCount?: number;
}
const initialState: iSideBar = {
  sidebarHidden: true,
  sidebarExpanded: false,
  sidebarChats: false,
  titleTab: "",
  lastMessageSent: "",
  allDialogs: [],
  updateShowInput: false,
  notificationCount: 0
};
const sidebarInteractionsSlice = createSlice({
  name: "sidebarInteractions",
  initialState,
  reducers: {
    toggleShowSidebar(state) {
      state.sidebarHidden = !state.sidebarHidden;
    },
    toggleSidebarExpanded(state) {
      state.sidebarExpanded = !state.sidebarExpanded;
    },
    setSidebarExpanded(state, action: PayloadAction<boolean>) {
      state.sidebarExpanded = action.payload;
    },
    setSidebarChats(state, action: PayloadAction<boolean>) {
      state.sidebarChats = action.payload;
    },
    setTitleTab(state, action: PayloadAction<string>) {
      state.titleTab = action.payload;
    },
    setLastMessageSent(state, action: PayloadAction<string>) {
      state.lastMessageSent = action.payload;
    },
    setAllDialogs(state, action: PayloadAction<number[]>) {
      state.allDialogs = action.payload;
    },
    setUpdateShowInput(state, action: PayloadAction<boolean>) {
      state.updateShowInput = action.payload;
    },
    setNotificationCount(state, action: PayloadAction<number>) {
      state.notificationCount = action.payload;
    }
  }
});

export const {
  toggleShowSidebar,
  toggleSidebarExpanded,
  setSidebarExpanded,
  setSidebarChats,
  setTitleTab,
  setLastMessageSent,
  setAllDialogs,
  setUpdateShowInput,
  setNotificationCount
} = sidebarInteractionsSlice.actions;

export default sidebarInteractionsSlice.reducer;
